import styled from "styled-components";

export const StatusBadge = styled.span`
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-block;

  ${(props) =>
    props.$isPublic
      ? `
    background: #d4edda;
    color: #155724;
  `
      : `
    background: #f8d7da;
    color: #721c24;
  `}
`;
